export const colorHex6 = /^#[\da-f]{6}$/i;
